import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { Check, ArrowRight, Clock, Settings, Users, ClipboardList } from 'lucide-react';

export default function Gracias() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-slate-950 flex items-center justify-center px-4 py-12" data-testid="gracias-page">
      <div className="max-w-lg w-full animate-fadeIn">
        <div className="w-20 h-20 rounded-full bg-emerald-500/20 flex items-center justify-center mx-auto mb-6">
          <Check className="w-10 h-10 text-emerald-400" strokeWidth={2.5} />
        </div>

        <h1 className="font-barlow text-3xl font-bold text-slate-50 uppercase mb-3 text-center">
          Bienvenido a Talleres PRO
        </h1>
        <p className="text-slate-400 mb-8 text-center text-base">
          Tu cuenta ha sido creada exitosamente.
        </p>

        {/* Trial badge */}
        <div className="flex items-center justify-center gap-2 mb-8">
          <div className="inline-flex items-center gap-2 bg-amber-500/10 border border-amber-700/50 rounded-sm px-4 py-2">
            <Clock className="w-4 h-4 text-amber-500" />
            <span className="text-sm text-amber-400 font-medium">7 dias de prueba gratis activados</span>
          </div>
        </div>

        {/* Quick start steps */}
        <Card className="bg-slate-900/60 border-slate-800 mb-6">
          <CardContent className="p-5">
            <p className="text-xs uppercase tracking-wider text-slate-500 font-semibold mb-4">Empieza en 3 pasos:</p>
            <div className="space-y-4">
              {[
                { icono: Settings, paso: '1', titulo: 'Configura tu negocio', desc: 'Agrega nombre, logo, horario y datos fiscales' },
                { icono: ClipboardList, paso: '2', titulo: 'Crea tus servicios', desc: 'Define los servicios y precios que ofreces' },
                { icono: Users, paso: '3', titulo: 'Registra tu primer cliente', desc: 'Empieza a gestionar ordenes y pagos' },
              ].map((item) => {
                const Icon = item.icono;
                return (
                  <div key={item.paso} className="flex items-start gap-3">
                    <div className="w-8 h-8 rounded-full bg-amber-500/10 flex items-center justify-center shrink-0">
                      <span className="text-sm font-bold text-amber-500">{item.paso}</span>
                    </div>
                    <div>
                      <p className="text-sm font-medium text-slate-200">{item.titulo}</p>
                      <p className="text-xs text-slate-500">{item.desc}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </CardContent>
        </Card>

        <Button onClick={() => { window.location.href = '/login'; }} size="lg"
          className="w-full bg-amber-500 hover:bg-amber-600 text-black font-bold rounded-sm text-base h-12 shadow-[0_0_20px_rgba(245,158,11,0.3)] transition-all"
          data-testid="gracias-entrar-btn">
          Iniciar Sesion y Empezar <ArrowRight className="w-5 h-5 ml-2" />
        </Button>

        <div className="mt-6 text-center space-y-1">
          <p className="text-xs text-slate-600">
            Tu prueba gratis termina en 7 dias.
          </p>
          <p className="text-xs text-slate-600">
            Despues: deposito bancario ($399/mes) o tarjeta para cobro automatico.
          </p>
        </div>
      </div>
    </div>
  );
}
